var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.209 1.06099C7.934 0.979994 8.363 0.979994 9.142 1.06099C10.5209 1.26509 11.7992 1.90248 12.792 2.88099C12.1211 3.51513 11.4591 4.15852 10.806 4.81099C9.55533 3.75099 8.15933 3.50633 6.618 4.07699C5.48733 4.59699 4.7 5.43966 4.256 6.60499C3.53044 6.06482 2.81433 5.51207 2.108 4.94699C2.05891 4.92116 2.00285 4.9117 1.948 4.91999C3.07 2.75666 4.82333 1.46999 7.208 1.05999",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94601 4.92C2.00267 4.91133 2.05634 4.92033 2.10701 4.947C2.81334 5.51208 3.52945 6.06483 4.25501 6.605C4.14083 7.05906 4.06886 7.52269 4.04001 7.99C4.06467 8.442 4.13634 8.88566 4.25501 9.321L2.00001 11.116C1.01801 9.064 1.00001 6.99866 1.94601 4.92Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.685 13.29C11.9829 12.6708 11.2478 12.0899 10.483 11.55C11.2497 11.0087 11.715 10.266 11.879 9.32199H8.12201V6.71299C10.2887 6.69499 12.4543 6.71332 14.619 6.76799C15.0297 8.99799 14.5553 11.0087 13.196 12.8C13.0344 12.9718 12.8632 13.1354 12.685 13.29Z",
    fill: "#448AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.255 9.32202C5.075 11.36 6.57833 12.3114 8.765 12.176C9.37883 12.105 9.96735 11.8905 10.483 11.55C11.2483 12.0914 11.9823 12.6714 12.685 13.29C11.5716 14.2905 10.1521 14.8841 8.658 14.974C8.31854 15.0012 7.97746 15.0012 7.638 14.974C5.09267 14.674 3.21333 13.388 2 11.116L4.255 9.32202Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.3884b6f8c67dda243bece134b61ffc06.svg";
export { ForwardRef as ReactComponent };